class SubscriptionEventDelegator {
  constructor(widget) {
    this.widget = widget;
    this.subscriptionSelect = this.widget.querySelector(
      ".subscription-details select"
    );
    this.rechargeWidget = document.querySelector(
      "recharge-subscription-widget"
    ).shadowRoot;
    this.oneTimeButton = this.rechargeWidget.querySelector(
      ".rc-purchase-option.rc-selection__onetime label"
    );
    this.subscriptionButton = this.rechargeWidget.querySelector(
      ".rc-purchase-option.rc-purchase-option__subscription label"
    );
    this.subscriptionPlans =
      this.rechargeWidget.querySelector("rc-selling-plans").shadowRoot;
    this.twoWeekPlanButton = this.subscriptionPlans
      .querySelector('input[value="5969346748"]')
      .closest("label");
    this.fourWeekPlanButton = this.subscriptionPlans
      .querySelector('input[value="5969379516"]')
      .closest("label");
    this.sixWeekPlanButton = this.subscriptionPlans
      .querySelector('input[value="5969412284"]')
      .closest("label");
    this.init();
  }

  init() {
    this.addEventListeners();
  }

  handleSubscriptionSelect() {
    this.subscriptionButton.click();
    // Get plan selected:
    if (this.subscriptionSelect.value == "2") {
      this.twoWeekPlanButton.click();
    } else if (this.subscriptionSelect.value == "4") {
      this.fourWeekPlanButton.click();
    } else {
      this.sixWeekPlanButton.click();
    }
  }

  handleOneTimeSelect() {
    this.oneTimeButton.click();
  }

  addEventListeners() {
    this.subscriptionSelect.addEventListener("change", (e) => {
      this.subscriptionButton.click();
      // Get plan selected:
      if (e.target.value == "2") {
        this.twoWeekPlanButton.click();
      } else if (e.target.value == "4") {
        this.fourWeekPlanButton.click();
      } else {
        this.sixWeekPlanButton.click();
      }
    });
    this.widget.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener("input", (e) => {
        if (e.target.value == "subscribe") {
          this.handleSubscriptionSelect();
        } else {
          this.handleOneTimeSelect();
        }
      });
    });
  }
}


document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".product-form-accordion");

  accordions.forEach((accordion) => {
    setTimeout(()=>{
    new SubscriptionEventDelegator(accordion)

    }, 1500)
  });
});




